import * as React from 'react';
import TextField from "@material-ui/core/TextField";
import Translate from '../../common/functions/translate';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import { OfferFilterSettingsModel } from "../../models/offer/offerFilterSettingsModel";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTimes, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import Paper from '@material-ui/core/Paper';
import { DropdownModel } from '../../models/dropdownModel';
import RegionService from '../../services/regionService';
import { RegionModel } from '../../models/region';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import MenuItem from '@material-ui/core/MenuItem';
import { TimePeriod, OfferStatus } from '../../common/enums';
import AuthService from '../../services/authService';
import * as Modal from '../../common/components/modal/modalDialog';
import Dialog from '@material-ui/core/Dialog';
import { DatePicker } from "@material-ui/pickers";
import Snackbar from "../../common/components/snackbar/snackbar";

const themeDialog = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '40%'
      }
    },
  },
  palette: {
    primary: blue
  }
})

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number;
  transferButtonDisabled: boolean;
  transferButtonClick: any;
  trasferOffersCount: number;
  isVisibleTransferButton: boolean
}

interface IState {
  offerSettings: OfferFilterSettingsModel,
  filterText: string,
  timePeriods: Array<DropdownModel>;
  regions: Array<DropdownModel>;
  statuses: Array<DropdownModel>;
  isTimePeriodDialogOpen: boolean;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: 200
      }
    }
  },
  palette: {
    primary: blue
  }
});

export class OfferFilter extends React.Component<IProps, IState>  {
  snackbar: any;
  authService = new AuthService();
  regionService = new RegionService();

  constructor(props) {
    super(props);
    this.state = {
      offerSettings: new OfferFilterSettingsModel(),
      filterText: '',
      timePeriods: new Array<DropdownModel>(0),
      regions: new Array<DropdownModel>(0),
      statuses: new Array<DropdownModel>(0),
      isTimePeriodDialogOpen: false,
    };
  }

  componentDidMount() {
    const timePeriods: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 },];
    const regions: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    let statuses: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    statuses = statuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true));
    // Add Sent status after New
    let sent = statuses.pop();
    if (sent)
      statuses.splice(2, 0, sent);

    this.setState({
      timePeriods: timePeriods.concat(HelperFunctions.enumToDropdownArray(TimePeriod, true)),
      statuses: statuses,
    });

    if (this.authService.checkIsAdmin()) {
      this.regionService.getAllActiveRegions().then(
        (data: Array<RegionModel>) => {
          let regData = new Array<DropdownModel>(0);
          data.forEach(r => regData.push({ label: r.name, value: r.id }));

          this.setState({
            regions: regions.concat(regData)
          });
        })
        .catch(error => {
          this.snackbar.show({ severity: 'error', summary: error.message });
        });
    }
  }

  handleChange = (key, value) => {
    if ((key === 'timePeriodId' && value === 0) || (key === 'regionId' && value === 0) || (key === 'statusId' && value === 0)) {
      value = undefined;
    }

    if (key === 'startDate' || key === 'endDate') {
      if (value) {
        value = HelperFunctions.fomatDateAsString(value);
      }
    }

    const offerSettings: OfferFilterSettingsModel = { ...this.state.offerSettings };

    if (key === 'timePeriodId' && value) {
      let startDate = new Date();
      let endDate = new Date();
      let monthsAgo = this.getMonthsAgoValue(value);

      startDate.setMonth(startDate.getMonth() - monthsAgo);

      offerSettings.startDate = HelperFunctions.fomatDateAsString(startDate);
      offerSettings.endDate = HelperFunctions.fomatDateAsString(endDate);
    }

    offerSettings[key] = value;
    const fiterText = this.generateFilterText(offerSettings);
    this.setState({ offerSettings: { ...offerSettings }, filterText: fiterText });
  };

  getMonthsAgoValue = (value) => {
    switch (value) {
      case 1: {
        return 1;
      }
      case 2: {
        return 3;
      }
      case 3: {
        return 12;
      }
      default: {
        return 0;
      }
    }
  }

  generateFilterText = (settings: OfferFilterSettingsModel) => {
    let result = '';

    // if (settings.timePeriodId) {
    //   result += Translate("Period") + " <strong>'" + HelperFunctions.getEnumLabel(settings.timePeriodId, TimePeriod, true) + "'</strong>, "
    // }

    if (settings.startDate) {
      result += Translate("From") + " <strong>'" + HelperFunctions.fomatDatesStringWithLang(new Date(settings.startDate)) + "'</strong>, "
    }

    if (settings.endDate) {
      result += Translate("To") + " <strong>'" + HelperFunctions.fomatDatesStringWithLang(new Date(settings.endDate)) + "'</strong>, "
    }

    if (settings.regionId) {
      result += Translate("Region") + " <strong>'" + this.returnRegionLabel(settings.regionId) + "'</strong>, "
    }

    if (settings.statusId) {
      result += Translate("Status") + " <strong>'" + this.returnStatusLabel(settings.statusId) + "'</strong>, "
    }

    if (settings.traderName) {
      result += Translate("Trader") + " <strong>'" + settings.traderName + "'</strong>, "
    }

    if (settings.city) {
      result += Translate("City") + " <strong>'" + settings.city + "'</strong>, "
    }

    if (settings.price) {
      result += Translate("Price") + " <strong>'" + settings.price + "'</strong>, "
    }

    if (settings.boilerMake) {
      result += Translate("BoilerMake") + " <strong>'" + settings.boilerMake + "'</strong>, "
    }

    return result.substr(0, result.length - 2);
  }

  returnRegionLabel = (id) => {
    let regionDropdown = this.state.regions.find(r => r.value === id);
    if (regionDropdown && regionDropdown.value) {
      return regionDropdown.label;
    }
    return '';
  }

  returnStatusLabel = (id) => {
    let statusDropdown = this.state.statuses.find(r => r.value === id);
    if (statusDropdown && statusDropdown.value) {
      return statusDropdown.label;
    }
    return '';
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      offerSettings: new OfferFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new OfferFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.offerSettings)
    }
  }

  handleTimePeriodOKClick = (show: boolean) => {
    this.setState({
      isTimePeriodDialogOpen: show
    })
  }

  handleTimePeriodOpenClick = (show: boolean) => {
    let offerSettings: OfferFilterSettingsModel = { ...this.state.offerSettings }

    if (!offerSettings.timePeriodId) {
      this.handleChange("timePeriodId", 1);
    }

    this.setState({
      isTimePeriodDialogOpen: show
    })
  }

  handleTimePeriodCancelClick = () => {
    let offerSettings: OfferFilterSettingsModel = { ...this.state.offerSettings }
    offerSettings.timePeriodId = undefined;
    offerSettings.startDate = undefined;
    offerSettings.endDate = undefined;

    const filterText = this.generateFilterText(offerSettings);

    this.setState({
      isTimePeriodDialogOpen: false,
      filterText: filterText,
      offerSettings: offerSettings
    })
  }


  render() {
    return (
      <>
        <Snackbar ref={(el) => this.snackbar = el} />

        <Paper style={{ padding: 10, marginBottom: 15, backgroundColor: "#f5f5f5" }} >
          <div>
            <MuiThemeProvider theme={theme}>
              <FormControl style={{ marginRight: 10 }}>
                <TextField
                  select
                  InputProps={{
                    readOnly: true
                  }}
                  label={Translate('Period')}
                  value={this.state.offerSettings.timePeriodId ? this.state.offerSettings.timePeriodId : ''}
                  onClick={() => this.handleTimePeriodOpenClick(!this.state.isTimePeriodDialogOpen)}
                >
                  {
                    this.state.timePeriods.map(m => <MenuItem key={m.value + 'timePeriod'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                  }
                </TextField>
              </FormControl>
              <FormControl>
                <InputLabel htmlFor="status-label">{Translate('Status')}</InputLabel>
                <Select
                  name="statusId"
                  value={this.state.offerSettings.statusId ? this.state.offerSettings.statusId : ''}
                  onChange={(e) => this.handleChange('statusId', e.target.value)}
                  style={{ marginRight: 10 }}
                  inputProps={{
                    id: 'status-label'
                  }}
                >
                  {
                    this.state.statuses.map(m => <MenuItem key={m.value + 'status'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                  }
                </Select>
              </FormControl>
              {!this.authService.checkIsRegionalManager() && !this.authService.checkIsTrader()
                ? <FormControl>
                  <InputLabel htmlFor="region-label">{Translate('Region')}</InputLabel>
                  <Select
                    name="regionId"
                    value={this.state.offerSettings.regionId ? this.state.offerSettings.regionId : ''}
                    onChange={(e) => this.handleChange('regionId', e.target.value)}
                    style={{ marginRight: 10 }}
                    inputProps={{
                      id: 'region-label'
                    }}
                  >
                    {
                      this.state.regions.map(m => <MenuItem key={m.value + 'region'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                    }
                  </Select>
                </FormControl>
                : null
              }
              {!this.authService.checkIsTrader()
                ? <TextField
                  onKeyPress={(e) => this.handleKeyPress(e)}
                  name="traderName"
                  label={Translate("TraderName")}
                  style={{ marginRight: 10 }}
                  type="text"
                  onChange={(e) => this.handleChange('traderName', e.target['value'])}
                  value={this.state.offerSettings && this.state.offerSettings.traderName ? this.state.offerSettings.traderName : ""}
                />
                : null}
              <TextField
                onKeyPress={(e) => this.handleKeyPress(e)}
                name="city"
                style={{ marginRight: 10 }}
                label={Translate("City")}
                onChange={(e) => this.handleChange('city', e.target['value'])}
                value={this.state.offerSettings && this.state.offerSettings.city ? this.state.offerSettings.city : ""}
              />
              {/* <TextField
                onKeyPress={(e) => this.handleKeyPress(e)}
                name="boilerMake"
                style={{ marginRight: 10 }}
                label={Translate("BoilerMake")}
                onChange={(e) => this.handleChange('boilerMake', e.target['value'])}
                value={this.state.offerSettings && this.state.offerSettings.boilerMake ? this.state.offerSettings.boilerMake : ""}
              /> */}
              <TextField
                onKeyPress={(e) => this.handleKeyPress(e)}
                name="price"
                type={"number"}
                style={{ marginRight: 10 }}
                label={Translate("MaxPrice")}
                onChange={(e) => this.handleChange('price', e.target['value'])}
                value={this.state.offerSettings && this.state.offerSettings.price ? this.state.offerSettings.price : ""}
              />
            </MuiThemeProvider>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5 }}>
            <div style={{ fontSize: "0.9em" }}>
              {Translate('Result')}: <strong>{this.props.totalRecordsCount}</strong>
              {this.state.filterText ? ', ' : ''}
              <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
            </div>
            <div>
              {this.props.isVisibleTransferButton ?
                <Button
                  disabled={this.props.transferButtonDisabled}
                  color="primary"
                  variant="contained"
                  style={{ marginRight: 20 }}
                  size="small"
                  onClick={() => this.props.transferButtonClick()}>
                  <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: 10 }} />
                  {Translate("Transfer")} {this.props.trasferOffersCount ? "(" + this.props.trasferOffersCount + ")" : null}
                </Button>
                : null}
              <Button
                color="primary"
                variant="contained"
                style={{ marginRight: 10 }}
                size="small"
                onClick={() => this.handleSearchButtonClick(this.state.offerSettings)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
                {Translate("Filter")}
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() => this.handleClearButtonClick()}>
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: 10 }} />
                {Translate("Clear")}
              </Button>
            </div>
          </div>
        </Paper>


        <MuiThemeProvider theme={themeDialog}>
          <Dialog

            disableBackdropClick
            disableEscapeKeyDown
            open={this.state.isTimePeriodDialogOpen}
            onClose={() => this.handleTimePeriodCancelClick()}
          >
            <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.handleTimePeriodCancelClick()}>{Translate('ChoosePeriod')}</Modal.DialogTitle>
            <Modal.DialogContent>
              <div style={{ minHeight: "150px" }}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel htmlFor="timePeriod-label">{Translate('Period')}</InputLabel>
                  <Select
                    name="timePeriodId"
                    value={this.state.offerSettings.timePeriodId ? this.state.offerSettings.timePeriodId : ''}
                    onChange={(e) => this.handleChange('timePeriodId', e.target.value)}
                    style={{ marginRight: 10 }}
                    inputProps={{
                      id: 'timePeriod-label'
                    }}
                  >
                    {
                      this.state.timePeriods.map(m => <MenuItem key={m.value + 'timePeriod'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                    }
                  </Select>
                </FormControl>

                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15, alignItems: 'flex-end' }}>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: "50%" }}>
                    <div>
                      {/* <label style={{ width: "100%", color: "rgba(0, 0, 0, 0.54)", fontSize: "13px" }}>{Translate("From")}</label> */}
                      <DatePicker
                        emptyLabel={Translate("From")}
                        format={Translate('DateFormatUS')}
                        value={this.state.offerSettings && this.state.offerSettings.startDate ? new Date(this.state.offerSettings.startDate) : null}
                        onChange={(e) => this.handleChange("startDate", e)}
                      />
                    </div>
                    <div onClick={() => this.handleChange("startDate", undefined)} style={{ padding: 5, cursor: "pointer" }}>
                      <FontAwesomeIcon icon={faTimes} style={{ color: '#808080', fontSize: '1.1em', margin: '0 2px' }} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: "50%", marginLeft: "10px" }}>
                    <div>
                      {/* <label style={{ width: "100%", color: "rgba(0, 0, 0, 0.54)", fontSize: "13px" }}>{Translate("To")}</label> */}
                      <DatePicker
                        emptyLabel={Translate("To")}
                        format={Translate('DateFormatUS')}
                        value={this.state.offerSettings && this.state.offerSettings.endDate ? new Date(this.state.offerSettings.endDate) : null}
                        onChange={(e) => this.handleChange("endDate", e)}
                      />
                    </div>
                    <div onClick={() => this.handleChange("endDate", undefined)} style={{ padding: 5, cursor: "pointer" }}>
                      <FontAwesomeIcon icon={faTimes} style={{ color: '#808080', fontSize: '1.1em', margin: '0 2px' }} />
                    </div>
                  </div>

                </div>
              </div>
            </Modal.DialogContent>
            <Modal.DialogActions>
              <Button onClick={() => this.handleTimePeriodCancelClick()} variant="contained" style={{ marginRight: 10 }}>
                {Translate('Cancel')}
              </Button>
              <Button onClick={() => this.handleTimePeriodOKClick(!this.state.isTimePeriodDialogOpen)} color="primary" variant="contained">
                {Translate('Ok')}
              </Button>
            </Modal.DialogActions>
          </Dialog>
        </MuiThemeProvider>

      </>
    )
  }
}

export default OfferFilter;
